import { BaseSerializer } from "./baseSerializer.ts";
import { TeamMember, TeamRole } from "@models/teamMember.model.ts";
import { EmployeeSerializer } from "@models/serializers/employeeSerializer.ts";

export class TeamMemberSerializer extends BaseSerializer {
  public deserialize(data: Record<string, any>): TeamMember {
    const team_member = new TeamMember();

    this._copyAttributes(team_member, data);

    if (data.employee) {
      const employeeSerializer = new EmployeeSerializer();
      team_member.employee = employeeSerializer.deserialize(data.employee);
    }

    team_member.roles = (data.roles ?? []).map((role: Record<string, any>) => {
      const teamRole = new TeamRole();
      this._copyAttributes(teamRole, role);
      return teamRole;
    });

    return team_member;
  }
}
